import { useState } from "react";
import "./Admin.css";

// Demo credentials — in real app use backend auth

export default function AdminLogin({ onLogin }) {
  const [email, setEmail]     = useState("");
  const [pass,  setPass]      = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake]     = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/admin/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email,
        password: pass
      })
    });

    const data = await res.json();

    if (!res.ok) {
      setError(data.error || "Login failed");
      setLoading(false);
      setShake(true);
      setTimeout(() => setShake(false), 600);
      return;
    }

    localStorage.setItem("adminToken", data.token);
    onLogin();
  } catch (err) {
    console.error(err);
    setError("Server error. Please try again.");
    setLoading(false);
    setShake(true);
    setTimeout(() => setShake(false), 600);
  }
};

  return (
    <div className="admin-login-page">
      {/* Animated background */}
      <div className="login-bg">
        <div className="login-orb o1" />
        <div className="login-orb o2" />
        <div className="login-orb o3" />
        <div className="login-grid" />
      </div>

      <div className={`login-card ${shake ? "shake" : ""}`}>
        {/* Logo */}
        <div className="login-logo">
          <div className="login-logo-icon">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M14 3C10 3 7 6.5 7 10.5c0 2 .8 3.8 2 5L14 25l5-9.5c1.2-1.2 2-3 2-5C21 6.5 18 3 14 3z"
                fill="#fff" fillOpacity=".95"/>
              <ellipse cx="11" cy="9" rx="2.5" ry="1.4" fill="white" fillOpacity=".4"/>
            </svg>
          </div>
          <div>
            <div className="login-clinic-name">Krishna Dental</div>
            <div className="login-clinic-sub">Admin Portal</div>
          </div>
        </div>

        <h2 className="login-title">Welcome back</h2>
        <p className="login-sub">Sign in to manage appointments and patients</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Email Address</label>
            <div className="login-input-wrap">
              <span className="linput-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    stroke="currentColor" strokeWidth="2"/>
                  <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              <input
                type="email" placeholder="Enter Admin email"
                value={email} onChange={e => setEmail(e.target.value)}
                required autoComplete="email"
              />
            </div>
          </div>

          <div className="login-field">
            <label>Password</label>
            <div className="login-input-wrap">
              <span className="linput-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              <input
                type={showPass ? "text" : "password"}
                placeholder="Enter your password"
                value={pass} onChange={e => setPass(e.target.value)}
                required autoComplete="current-password"
              />
              <button type="button" className="show-pass" onClick={() => setShowPass(s => !s)}>
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {error && (
            <div className="login-error">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              {error}
            </div>
          )}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? (
              <span className="login-spinner" />
            ) : (
              <>
                Sign In
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </>
            )}
          </button>
        </form>

        <a href="#home" className="login-back" onClick={() => { window.location.hash = ""; }}>
          ← Back to website
        </a>
      </div>
    </div>
  );
}